module.exports = __webpack_public_path__ + "img/img003.54600418.png";